/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    var capsule_is_single = function() {
        return $('.mainLink').length;
    };

    var create_capsule = function (response) {
        var mode = capsule_is_single() ? 'single' : 'multi';
        return $(mode == 'multi' ? response.capsule : response.capsule_single);
    };

    /**
     * Copy and animate short URL
     */
    var copy_capsule_url = new Clipboard('[data-clipboard-text]');
    copy_capsule_url.on('success', function(e) {
        animation_target = $($(e.trigger).data('animation-target'));
        animation_target.addClass('copied');

        setTimeout(
            function() {
                animation_target.removeClass('copied');
            },
            500
        );
        e.clearSelection();
    });

    /**
     * Capsule dashboard list
     */
    if (typeof load_capsule_page != 'undefined') {
        var link_list = $('.capsules-list');
        var show_more = $('.show-more-wrapper');
        var loading = $('.preloader-wrapper');
        var filters = $('.filter');

        /**
         *
         */
        var load_capsules = function(reload) {
            show_more.hide();
            loading.show();
            if (load_capsule_page == 1 && reload != true) {
                filters.hide();
            }

            $.get(
                load_capsule_url + '?page=' + load_capsule_page + '&sort=' + sort_type + '&folder=' + sort_folder + '&domain=' + sort_domain + '&attributes=' + sort_attributes + '&search=' + encodeURIComponent(search_phrase),
                function(response) {
                    filters.show();
                    loading.hide();
                    if (response.next) {
                        show_more.show();
                    }

                    load_capsule_page = response.next;
                    var capsules = $(response.capsules);
                    capsules.appendTo(link_list);
                },
                'json'
            );
        };

        /**
         *
         */
        var reload_capsules = function() {
            link_list.find('article, .no-capsules').remove();
            load_capsule_page = 1;
            load_capsules(true);
        };

        show_more.on('click', 'button', function() {
            load_capsules();
        });

        load_capsules();

        $('#sort-capsulations-dropdown').on('click', 'a', function() {
            sort_type = $(this).data('sort');
            reload_capsules();
        });

        $('#folder-capsulations-dropdown').on('click', 'a', function() {
            sort_folder = $(this).data('folder');
            reload_capsules();
        });

        $('#domain-capsulations-dropdown').on('click', 'a', function() {
            sort_domain = $(this).data('domain');
            reload_capsules();
        });

        $('#attributes-capsulations-dropdown').on('click', 'a', function() {
            sort_attributes = $(this).data('attributes');
            reload_capsules();
        });
    }

    /**
     * Capsule title/description edit
     */
    $('.capsules-list').on('click', '[data-edit]', function() {
        var form = $($(this).data('edit'));

        var input = form.find('textarea');
        input.val($(this).data('value'));

        form.fadeIn(function() {
            input.autosize();
        });

        if ($(form).is(':visible')) {
            $(this).addClass('active');
        }
        else {
            $(this).removeClass('active');
        }

        return false;
    })
    .on('click', '.button-cancel', function() {
        var form = $(this).closest('form');
        var btn = $('.edit[data-edit="#' + form.attr('id') + '"]');

        $(btn).removeClass('active');
        form.fadeOut(function() {
            form.find('textarea').autosize();
            form.find('textarea').removeClass('error');
        });

        return false;
    })
    .on('click', '.button-save', function() {
        var form = $(this).closest('form');
        var btn = $('.edit[data-edit="#' + form.attr('id') + '"]');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                if (response.status == 'success') {
                    $(btn).removeClass('active');
                    form.fadeOut(function() {
                        var capsule = $(response.capsule);
                        form.closest('article').replaceWith(capsule);
                    });
                }
                else {
                    form.find('textarea').addClass('error');
                }

                info(response.message);
            },
            'json'
        );

        return false;
    })
    .on('keyup', '[name=title]', function (e) {
        if (e.which == 27) {
            e.preventDefault();
            $(this).closest('form').find('.button-cancel').trigger('click');
        }
    })
    .on('keypress', '[name=title]', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $(this).closest('form').find('.button-save').trigger('click');
        }
    })
    /**
     * Capsule URL edit
     */
    .on('click', '.button-edit-url-save', function(){
        var btn = $(this);
        var form = btn.closest('form');

        if (btn.hasClass('active')) {
            $.post(
                form.attr('action'),
                form.serialize(),
                function(response) {
                    if (response.status == 'success') {
                        btn.removeClass('active').text('EDIT');
                        var capsule = $(response.capsule);
                        form.closest('article').replaceWith(capsule);
                    }
                    else {
                        btn.siblings('input[name=url]').addClass('error');
                    }

                    info(response.message);
                },
                'json'
            );
        }
        else {
            btn.siblings('input[name=url]').focus();
            return false;
        }
    })
    .on('focus', '.url input[name=url]', function(){
        $(this).trigger('change');
    })
    .on('click', '.button-edit-url-cancel', function(){
        var btn = $(this);
        btn.siblings('.button-edit-url').removeClass('active').text('EDIT');
        btn.removeClass('active');
        btn.siblings('input[name=url]').val(btn.data('original-value')).removeClass('error').blur();

        return false;
    })
    .on('keyup', '.url input[name=url]', function (e) {
        if (e.which == 27) {
            e.preventDefault();
            $(this).closest('form').find('.button-edit-url-cancel').trigger('click');
        }
    })
    .on('keypress', '.url input[name=url]', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $(this).closest('form').find('.button-edit-url-save').trigger('click');
        }
    })
    /**
     * Capsule custom short URL edit
     */
    .on('click', '.button-edit-short_url', function(){
        var btn = $(this);
        btn.closest('.short-link').hide();

        var input = btn.closest('.links').find('.url.short_url');
        input.show();
        input.find('input').focus();

        return false;
    })
    .on('click', '.button-edit-short_url-cancel', function(){
        var btn = $(this);

        var input = btn.closest('.url.short_url');
        input.hide();
        input.find('input[name=short_url]').val(btn.data('original-value')).removeClass('error');

        var copy = btn.closest('.links').find('.short-link');
        copy.show();

        return false;
    })
    .on('click', '.button-edit-short_url-save', function(){
        var btn = $(this);
        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                if (response.status == 'success') {
                    var capsule = $(response.capsule);
                    form.closest('article').replaceWith(capsule);
                }
                else {
                    form.find('input[name=short_url]').addClass('error');
                }

                info(response.message);
            },
            'json'
        );

        if (btn.data('popup') != '#go-pro-popup') {
            return false;
        }
    })
    .on('keyup', 'input[name=short_url]', function (e) {
        if (e.which == 27) {
            e.preventDefault();
            $(this).closest('form').find('.button-edit-short_url-cancel').trigger('click');
        }
    })
    .on('keypress', 'input[name=short_url]', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $(this).closest('form').find('.button-edit-short_url-save').trigger('click');
        }
    })
    ;

    /**
     * Capsule dropdown actions
     */
    $('body').on('click', '.dropdown.capsule-settings .action', function() {
        var is_delete = $(this).hasClass('delete');
        if (is_delete && !window.confirm($(this).data('confirm'))) {
            $(this).closest('.dropdown').fadeOut();
            return false;
        }

        var form = $(this).closest('form');
        var capsule = $('[data-capsule-id=' + form.find('[name=id]').val() + ']');
        $(this).closest('.dropdown').fadeOut();

        $.post(
            $(this).attr('href'),
            form.serialize(),
            function(response) {
                info(response.message);

                if (is_delete) {
                    if (capsule_is_single()) {
                        window.location.reload();
                    }
                    else {
                        capsule.remove();
                    }
                }
                else {
                    var capsule_new = create_capsule(response);
                    capsule.replaceWith(capsule_new);
                }
            },
            'json'
        );

        return false;
    });

    /**
     * Capsule dropdown password
     */
    $('body').on('click', '.dropdown.capsule-settings .password', function() {
        var form = $(this).closest('form');
        var popup = $('#set-password-popup');
        popup.find('[name=id]').val(form.find('[name=id]').val());
        popup.find('label.error').hide();
        popup.find('input[name=password]').removeClass('error').val('');
        popup.find('.set-password').removeClass('multi').addClass('single');
        $(this).closest('.dropdown').fadeOut();
        return false;
    });

    $('#set-password-popup').on('click', '.set-password.single', function() {
        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                if (response.status == 'success') {
                    var capsule = create_capsule(response);
                    $('[data-capsule-id=' + form.find('[name=id]').val() + ']').replaceWith(capsule);

                    info(response.message);
                    hidePopup();
                }
                else {
                    form.find('input[name=password]').addClass('error');
                    form.find('label.error').show();
                }
            },
            'json'
        );

        return false;
    });

    /**
     * Capsule move to folder
     */
    $('body').on('click', '.dropdown.capsule-folders .action', function() {
        var form = $(this).closest('form');
        var capsule = $('[data-capsule-id=' + form.find('[name=id]').val() + ']');

        $(this).closest('.dropdown').fadeOut();

        form.find('[name=folder_id]').val($(this).data('folder_id'));
        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                var capsule_new = create_capsule(response);
                capsule.replaceWith(capsule_new);

                info(response.message);
            },
            'json'
        );

        return false;
    });

     /**
      * Capsule settings Share/QR popups
      */
     $('body').on('click', '.dropdown.capsule-settings [data-popup-share-capsule]', function(e) {
         e.preventDefault();

         $(this).closest('.dropdown').fadeOut();

         var popup = $($(this).data('popup-share-capsule'));
         popup.appendTo($('#popup-wrapper'));
         popup.find('.button-tw').click();
         popup.find('label.error').hide();

         qr = popup.find('.media-image img');
         qr.prop('src', qr.data('src'));

         if ($('.popup:visible').length) {
             changePopup($($(this).data('popup-share-capsule')));
         } else {
             showPopup($($(this).data('popup-share-capsule')));
         }
     });

    /**
     * Share popup switch
     */
    $('body').on('click', '.popup.capsule-share .social-links .button', function() {
        var btn = $(this);
        var popup = btn.closest('.popup');
        var form = popup.find('form');

        popup.find('.social-links .button').removeClass('active');
        btn.addClass('active');

        popup.find('.disabled-share').hide();
        popup.find('.share-form-part').hide();

        if (popup.find('.disabled-share.' + btn.data('share')).length) {
            popup.find('.disabled-share.' + btn.data('share')).show();
        }
        else if (btn.data('share') == 'email') {
            popup.find('.share-form-part').show();
        }
        else {
            popup.find('.share-form-part:not(.receivers)').show();
        }

        form.find('[name=share]').val(btn.data('share'));

        return false;
    });

    /**
     * Share popup submit
     */
    $('body').on('click', '.popup.capsule-share .button.share', function() {
        var btn = $(this);
        var popup = btn.closest('.popup');
        var form = popup.find('form');

        var share_type = form.find('[name=share]').val();
        if (share_type == 'facebook') {
            var url = 'https://www.facebook.com/sharer/sharer.php?u=';
            url += encodeURIComponent(form.find('[name=share_url]').val());
            window.open(url, 'fbshare', 'width=640,height=320');
            return false;
        }
        else if (share_type == 'twitter') {
            var url = 'http://twitter.com/share?text=';
            url += encodeURIComponent(form.find('[name=message]').val())
            url += '&url=' + encodeURIComponent(form.find('[name=share_url]').val())
            window.open(url, 'twshare', 'width=640,height=320');
            return false;
        }
        else if (share_type == 'linkedin') {
            var url = 'https://www.linkedin.com/shareArticle?mini=true&url=';
            url += encodeURIComponent(form.find('[name=share_url]').val());
            url += '&title=' + encodeURIComponent(form.find('[name=message]').val());
            window.open(url, 'lishare', 'width=640,height=320');
            return false;
        }

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                popup.find('label.error').hide();
                popup.find('.form-field input.error, .form-field textarea.error').removeClass('error');

                if (response.status == 'success') {
                    hidePopup();
                    info(response.message);
                }
                else {
                    $.each(response.errors, function (k, v) {
                        var input = form.find('[name=' + k + ']');
                        input.addClass('error')
                            .closest('.form-field').find('label.error').show();
                    });
                }
            },
            'json'
        );

        return false;
    });

    /**
     * Simple sharing
     */
    $('body').on('click', '.simple-share', function() {
        var share_type = $(this).data('type');
        var share_title = $(this).data('title');
        var share_url = $(this).data('url');

        var url = null;
        if (share_type == 'facebook') {
            url = 'https://www.facebook.com/sharer/sharer.php?u=';
            url += encodeURIComponent(share_url);
            if (share_title != '') {
                url += '&t=' + share_title;
            }
            window.open(url, 'fbshare', 'width=640,height=320');
        }
        else if (share_type == 'twitter') {
            url = 'http://twitter.com/share?text=';
            if (share_title != '') {
                url += share_title;
            }
            url += '&url=' + encodeURIComponent(share_url)
            window.open(url, 'twshare', 'width=640,height=320');
        }
        else if (share_type == 'linkedin') {
            url = 'https://www.linkedin.com/shareArticle?mini=true&url=';
            url += encodeURIComponent(share_url);
            if (share_title != '') {
                url += '&title=' + share_title;
            }
            window.open(url, 'lishare', 'width=640,height=320');
        }

        return false;
    });

    /**
     * Capsule mass actions
     */
    $('body').on('click', '.capsules-list .filter + .additional-wrapper a.action', function() {
        var is_delete = $(this).hasClass('delete');
        if (is_delete && !window.confirm($(this).data('confirm'))) {
            return false;
        }

        var form = $(this).closest('form');
        var action = $(this).attr('href');

        var checked = $('.capsules-list .links-list-item [type=checkbox]:checked');
        checked.each(function (k, v) {
            var capsule = $(v).closest('.links-list-item');

            $.post(
                action,
                {
                    _token: form.find('[name=_token]').val(),
                    id: capsule.data('capsule-id')
                },
                function(response) {
                    info(response.message);

                    if (is_delete) {
                        capsule.remove();
                    }
                    else {
                        var capsule_new = $(response.capsule);
                        capsule.replaceWith(capsule_new);
                        capsule_new.find('[type=checkbox]').prop('checked', 'checked').trigger('change');
                    }
                },
                'json'
            );
        });

        return false;
    });

    /**
     * Capsule mass password
     */
    $('body').on('click', '.capsules-list .filter + .additional-wrapper a.password', function() {
        var popup = $('#set-password-popup');
        popup.find('label.error').hide();
        popup.find('input[name=password]').removeClass('error').val('');
        popup.find('.set-password').removeClass('single').addClass('multi');
        return false;
    });

    $('#set-password-popup').on('click', '.set-password.multi', function() {
        var form = $(this).closest('form');

        var checked = $('.capsules-list .links-list-item [type=checkbox]:checked');
        checked.each(function (k, v) {
            var capsule = $(v).closest('.links-list-item');
            $.post(
                form.attr('action'),
                {
                    _token: form.find('[name=_token]').val(),
                    password: form.find('[name=password]').val(),
                    id: capsule.data('capsule-id')
                },
                function(response) {
                    if (response.status == 'success') {
                        var capsule_new = $(response.capsule);
                        capsule.replaceWith(capsule_new);
                        capsule_new.find('[type=checkbox]').prop('checked', 'checked').trigger('change');

                        info(response.message);
                        hidePopup();
                    }
                    else {
                        form.find('input[name=password]').addClass('error');
                        form.find('label.error').show();
                    }
                },
                'json'
            );
        });

        return false;
    });

    /**
     * Single capsule view edit fields
     */
    var toggleField = function(href, isToShow) {
        if (href.length > 0) {
            href.prop('disabled', isToShow);
            href.next('.mainLink-form-actions').toggleClass('editing', !isToShow);
        }
    };

    $('.mainLink').on('click', '.js-editField', function(e) {
        e.preventDefault();

        var inp = $($(this).attr('href'));
        toggleField(inp, false);
    })
    .on('click', '.js-closeField', function(e) {
        e.preventDefault();

        var inp = $($(this).attr('href'));
        toggleField(inp, true);

        inp.val(inp.data('original-value'));
    })
    .on('click', '.js-saveField', function(e) {
        e.preventDefault();

        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                if (response.status == 'success') {
                    var capsule = create_capsule(response);
                    $('[data-capsule-id=' + form.find('[name=id]').val() + ']').replaceWith(capsule);
                }

                info(response.message);
            },
            'json'
        );
    })
    .on('click', '.js-fieldset', function(e) {
        if (e.target.tagName == 'INPUT') {
            $(this).find('.js-editField').click();
            $(this).find('input').focus();
        }
    })
    .on('keyup', '.mainLink-form-field', function (e) {
        if (e.which == 27) {
            e.preventDefault();
            $(this).closest('form').find('.js-closeField').trigger('click');
        }
    })
    .on('keypress', '.mainLink-form-field', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $(this).closest('form').find('.js-saveField').trigger('click');
        }
    })
    ;

    /**
     * Capsule scoring
     */
    $('body').on('click', '[data-score]', function() {
        $.post(
            $(this).data('score'),
            {
                id: $(this).data('id'),
                _token: $(this).data('token')
            },
            function(response) {
            },
            'json'
        );
    });
});
